export function convertToDMS(src) {
    function toDMS(n) {
        // The sign doesn't matter
        n = Math.abs(n);

        // Get the degrees
        const d = Math.floor(n);
        // Strip off the answer we already have
        n = n - d;
        // And then put the minutes before the '.'
        n *= 60;

        // Get the minutes
        const m = Math.floor(n);
        // Remove them from the answer
        n = n - m;
        // Put the seconds before the '.'
        n *= 60;

        // Get the seconds
        // Should this be round? Or rounded by special rules?
        const s = n.toFixed(2);  //Math.floor(n);

        // Put it together.
        return "" + d + " " + m + " " + s;
    }

    const dir0 = src[0] > 0 ? "N" : "S";
    const dir1 = src[1] > 0 ? "E" : "W";

    return (toDMS(src[1]) + dir1 + " , " + toDMS(src[0]) + dir0);

}
